import {
  type SearchChainEntry,
  type SearchSourceId,
} from "@/features/map/utils/buildSearchChain";

export interface PickRangeSearchSourceParams {
  /** `buildSearchChain` が返した優先順付きのソース列。 */
  chain: SearchChainEntry[];
  /** 図形検索（円 / ポリゴン）に対応しているソース。 */
  shapeCapable: ReadonlySet<SearchSourceId>;
}

/**
 * 範囲選択検索で使うデータソースを 1 つ選ぶ純粋関数。
 *
 * 単一検索（クリック / 地番 / 住所）は順に試して最初のヒットで打ち切るが、範囲検索は
 * 「範囲内の全筆」を返すためヒット打ち切りが成立しない。そこで同じチェーンから、
 * 図形検索に対応している最初の 1 件だけを選ぶ。
 *
 * チェーンは Tier 1（表示中）が先頭に並んでいるため、表示中のソースがあれば必ず
 * そちらが選ばれ、無いときだけ Tier 2（非表示）に落ちる。Tier 2 が選ばれた場合は
 * 見えている地図と結果がずれるので、呼び出し側が乖離を利用者に伝える。
 *
 * @returns 使うソースとその Tier。対応ソースが 1 つも無ければ undefined。
 */
export const pickRangeSearchSource = ({
  chain,
  shapeCapable,
}: PickRangeSearchSourceParams): SearchChainEntry | undefined =>
  chain.find((entry) => shapeCapable.has(entry.id));
